<p-dialog
  [(visible)]="isModalVisable"
  [style]="{ width: '30vw' }"
  (onHide)="closeAssignmentGroupValidationDailog()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{confirmationMessage}}</span>
  </div>
  <ng-template pTemplate="footer">    
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="close"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeAssignmentGroupValidationDailog()"
    >
    </p-button>

    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="confirmation"
      class="align-right"
      (debounceClick)="saveDocumentData()"
    >
    </p-button>
  </ng-template>
</p-dialog>
